export enum FilterSelector {
  Departments = 'departments',
  Jobs = 'jobs',
  HiringManagers = 'hiring_managers',
  Recruiters = 'recruiters',
}
